var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5068 0.447139C12.8121 0.727033 12.8327 1.20146 12.5528 1.5068L5.21951 9.5068C5.08128 9.65759 4.88746 9.74538 4.68294 9.74983C4.47842 9.75427 4.28097 9.67498 4.13632 9.53034L0.802983 6.197C0.51009 5.90411 0.51009 5.42923 0.802983 5.13634C1.09588 4.84345 1.57075 4.84345 1.86364 5.13634L4.64309 7.91579L11.4471 0.493211C11.727 0.187872 12.2014 0.167245 12.5068 0.447139Z",
    fill: "#273C49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkThin);
export default __webpack_public_path__ + "static/media/checkmark-thin.98df3636c5ee2af5ebfaefa554128646.svg";
export { ForwardRef as ReactComponent };